/* src/app/order/components/price-factors/price-factors.style.scss */
nb-radio {
  display: inline-block !important;
}
.form-row {
  flex-wrap: nowrap;
}
.price-factors .radio-button-group {
  margin-right: 30px;
  width: 140px;
  min-width: 140px;
}
.price-factors div:first-child {
  padding-right: 0;
}
.price-factors div:last-child {
  padding-left: 0;
}
.price-factors .price-factor-name {
  font-size: 15px;
  line-height: 1.47;
  color: #585858 !important;
  margin-top: auto;
  margin-bottom: auto;
}
.separator:not(.last) {
  margin-bottom: 25px !important;
}
.text-attached-question {
  margin-top: 5px;
}
@media screen and (max-width: 767px) {
  .form-row.price-factors {
    display: flex;
    flex-direction: column-reverse;
  }
}
/*# sourceMappingURL=price-factors.style.css.map */
